import { TermAssociation } from "@terms/models";

export const termsOrderMap: Record<TermAssociation, number> = {
  [TermAssociation.SiteWide]: 1,
  [TermAssociation.EntitledEntity]: 2,
  [TermAssociation.DocumentType]: 3,
  [TermAssociation.Reporting]: 4,
};
